import {FC} from "react";

export interface MobileTabs {
    id: MobileGroupName
    title: string
    icon: FC
}

export enum MobileGroupName {
    sizes = 'sizes',
    osnova = 'osnova',
    osnovaRemen = 'osnova-remen',
    meshok = 'meshok',
    remen = 'remen',
    accessories = 'accessories',
}
